// types
import { InputType, InputProps, InputSize } from './types';

// components
import Input from './input';

export default function InputNumber({
  title,
  onChange,
  name,
  className,
  size = InputSize.MEDIUM,
  disabled,
  placeholder,
  value,
  maxLength,
  error,
  prefix,
  suffix,
  onBlur,
  labelClassName = '',
  tabIndex,
  onFocus,
  inputRef,
  min,
  max,
  prefixClassName,
  suffixClassName,
}: InputProps): React.JSX.Element {
  return (
    <Input
      title={title}
      onChange={onChange}
      name={name}
      size={size}
      className={className}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      type={InputType.NUMBER}
      onBlur={onBlur}
      onFocus={onFocus}
      maxLength={maxLength}
      labelClassName={labelClassName}
      error={error}
      prefix={prefix}
      tabIndex={tabIndex}
      suffix={suffix}
      inputRef={inputRef}
      min={min}
      max={max}
      prefixClassName={prefixClassName}
      suffixClassName={suffixClassName}
    />
  );
}
